import { RadioGroup as BaseRadioGroup } from "@base-ui/react/radio-group";
import clsx from "clsx";
import type React from "react";
import { forwardRef, type HTMLAttributes } from "react";
import type { LABEL_POSITIONS } from "../../utils/consts";
import { Radio } from "../Radio";
import {
  errorSpanClass,
  optionsContainerClass,
  optionsContainerHorizontalClass,
  optionsContainerVerticalClass,
  radioGroupClass,
  radioGroupContainerClass,
} from "./styles.css";

interface RadioGroupProps extends HTMLAttributes<HTMLDivElement> {
  label?: string;
  name: string;
  options: Array<{ label: string; value: any }>;
  labelPosition?: keyof typeof LABEL_POSITIONS;
  customColor?: string;
  isRequired?: boolean;
  vertical?: boolean;
  gap?: string;
  error?: string;
  value?: any;
  onValueChange?: (value: any) => void;
  containerClassName?: string;
}

export const RadioGroup = forwardRef(function RadioGroup(
  {
    label,
    name,
    options,
    labelPosition = "right",
    customColor,
    isRequired,
    vertical = false,
    gap,
    error,
    value,
    onValueChange,
    className,
    containerClassName,
    style,
    ...props
  }: RadioGroupProps,
  ref: React.Ref<HTMLDivElement>,
) {
  const optionsClassName = `${optionsContainerClass} ${
    vertical ? optionsContainerVerticalClass : optionsContainerHorizontalClass
  }`;

  return (
    <div
      className={clsx(radioGroupContainerClass, containerClassName)}
      ref={ref}
      {...props}
    >
      {label && <label>{label}</label>}
      <BaseRadioGroup
        name={name}
        value={value}
        onValueChange={onValueChange}
        required={isRequired}
        className={radioGroupClass}
      >
        <div
          className={clsx(optionsClassName, className)}
          style={{ gap: gap, ...style }}
        >
          {options.map((option, index) => (
            <Radio
              key={index}
              label={option.label}
              value={option.value}
              labelPosition={labelPosition}
              customColor={customColor}
            />
          ))}
        </div>
      </BaseRadioGroup>
      {error && <span className={errorSpanClass}>{error}</span>}
    </div>
  );
});

RadioGroup.displayName = "RadioGroup";
